/**
 * Creative step 3 — text ranking as a door (user, 12/10/2026: "it should
 * open automatically"): the card's one line says what the next fill does
 * with the ranking and its rules, and clicking it opens the Flow
 * Optimizer-style window — Formula · Rules · Config, the ranked texts live on
 * the right (read only while it is open). Part of the inheritable Texts section.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { describeHourFormula, describeTextRankingAction } from '@trafficpulse/shared';

import { StepCard } from '@/components/ui';

import { OptimizerDialog } from '../../optimizer-dialog/OptimizerDialog';
import { rulesSummary } from '../../rules/rule-model';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { TextRankingContent } from './TextRankingContent';

export const TextRankingStep: FC<{ index: number; editor: ContainerEditor; countryKey: string; containerId?: string | null }> = ({ index, editor, countryKey, containerId = null }) => {
  const [open, setOpen] = useState(false);
  const ranking = editor.draft.creative.ranking;
  const summary = [describeTextRankingAction(ranking, editor.draft.creative.amount), `ranked on ${describeHourFormula(ranking.formula)}`, rulesSummary(ranking.rules)].filter(Boolean).join(' · ');
  return (
    <>
      <StepCard index={index} icon={SlidersHorizontal} title="Text ranking" summary={summary} onLaunch={() => setOpen(true)} />
      <OptimizerDialog open={open} onOpenChange={setOpen}>
        <TextRankingContent editor={editor} countryKey={countryKey} containerId={containerId} onClose={() => setOpen(false)} />
      </OptimizerDialog>
    </>
  );
};
